function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Config, MemoryStorage, UUID } from '@amplitude/analytics-core';
import { CookieStorage, getCookieName, getQueryParams, SessionManager, FetchTransport } from '@amplitude/analytics-client-common';
import { LocalStorage } from './storage/local-storage';
export const getDefaultConfig = () => {
  const cookieStorage = new MemoryStorage();
  const trackingOptions = {
    adid: true,
    carrier: true,
    deviceManufacturer: true,
    deviceModel: true,
    ipAddress: true,
    language: true,
    osName: true,
    osVersion: true,
    platform: true
  };
  return {
    cookieExpiration: 365,
    cookieSameSite: 'Lax',
    cookieSecure: false,
    cookieStorage,
    disableCookies: false,
    domain: '',
    sessionManager: new SessionManager(cookieStorage, ''),
    sessionTimeout: 30 * 60 * 1000,
    storageProvider: new MemoryStorage(),
    trackingOptions,
    transportProvider: new FetchTransport()
  };
};
export class ReactNativeConfig extends Config {
  constructor(apiKey, userId, options) {
    var _options$storageProvi, _options$transportPro, _options$cookieStorag, _options$sessionManag, _options$sessionTimeo, _options$cookieExpira, _options$cookieSameSi, _options$cookieSecure, _options$disableCooki, _options$domain, _this$lastEventTime, _options$trackingOpti;

    const defaultConfig = getDefaultConfig();
    super({
      flushIntervalMillis: 1000,
      flushMaxRetries: 5,
      flushQueueSize: 30,
      ...options,
      apiKey,
      storageProvider: (_options$storageProvi = options === null || options === void 0 ? void 0 : options.storageProvider) !== null && _options$storageProvi !== void 0 ? _options$storageProvi : defaultConfig.storageProvider,
      transportProvider: (_options$transportPro = options === null || options === void 0 ? void 0 : options.transportProvider) !== null && _options$transportPro !== void 0 ? _options$transportPro : defaultConfig.transportProvider
    });

    _defineProperty(this, "appVersion", void 0);

    _defineProperty(this, "cookieExpiration", void 0);

    _defineProperty(this, "cookieSameSite", void 0);

    _defineProperty(this, "cookieSecure", void 0);

    _defineProperty(this, "cookieStorage", void 0);

    _defineProperty(this, "disableCookies", void 0);

    _defineProperty(this, "domain", void 0);

    _defineProperty(this, "partnerId", void 0);

    _defineProperty(this, "sessionTimeout", void 0);

    _defineProperty(this, "trackingOptions", void 0);

    _defineProperty(this, "sessionManager", void 0);

    this.cookieStorage = (_options$cookieStorag = options === null || options === void 0 ? void 0 : options.cookieStorage) !== null && _options$cookieStorag !== void 0 ? _options$cookieStorag : defaultConfig.cookieStorage;
    this.sessionManager = (_options$sessionManag = options === null || options === void 0 ? void 0 : options.sessionManager) !== null && _options$sessionManag !== void 0 ? _options$sessionManag : defaultConfig.sessionManager;
    this.sessionTimeout = (_options$sessionTimeo = options === null || options === void 0 ? void 0 : options.sessionTimeout) !== null && _options$sessionTimeo !== void 0 ? _options$sessionTimeo : defaultConfig.sessionTimeout;
    this.appVersion = options === null || options === void 0 ? void 0 : options.appVersion;
    this.cookieExpiration = (_options$cookieExpira = options === null || options === void 0 ? void 0 : options.cookieExpiration) !== null && _options$cookieExpira !== void 0 ? _options$cookieExpira : defaultConfig.cookieExpiration;
    this.cookieSameSite = (_options$cookieSameSi = options === null || options === void 0 ? void 0 : options.cookieSameSite) !== null && _options$cookieSameSi !== void 0 ? _options$cookieSameSi : defaultConfig.cookieSameSite;
    this.cookieSecure = (_options$cookieSecure = options === null || options === void 0 ? void 0 : options.cookieSecure) !== null && _options$cookieSecure !== void 0 ? _options$cookieSecure : defaultConfig.cookieSecure;
    this.deviceId = options === null || options === void 0 ? void 0 : options.deviceId;
    this.disableCookies = (_options$disableCooki = options === null || options === void 0 ? void 0 : options.disableCookies) !== null && _options$disableCooki !== void 0 ? _options$disableCooki : defaultConfig.disableCookies;
    this.domain = (_options$domain = options === null || options === void 0 ? void 0 : options.domain) !== null && _options$domain !== void 0 ? _options$domain : defaultConfig.domain;
    this.lastEventTime = (_this$lastEventTime = this.lastEventTime) !== null && _this$lastEventTime !== void 0 ? _this$lastEventTime : options === null || options === void 0 ? void 0 : options.lastEventTime;
    this.optOut = Boolean(options === null || options === void 0 ? void 0 : options.optOut);
    this.partnerId = options === null || options === void 0 ? void 0 : options.partnerId;
    this.sessionId = options === null || options === void 0 ? void 0 : options.sessionId;
    this.trackingOptions = (_options$trackingOpti = options === null || options === void 0 ? void 0 : options.trackingOptions) !== null && _options$trackingOpti !== void 0 ? _options$trackingOpti : defaultConfig.trackingOptions;
    this.userId = userId;
  }

  get deviceId() {
    return this.sessionManager.getDeviceId();
  }

  set deviceId(deviceId) {
    this.sessionManager.setDeviceId(deviceId);
  }

  get userId() {
    return this.sessionManager.getUserId();
  }

  set userId(userId) {
    this.sessionManager.setUserId(userId);
  }

  get sessionId() {
    return this.sessionManager.getSessionId();
  }

  set sessionId(sessionId) {
    this.sessionManager.setSessionId(sessionId);
  }

  get optOut() {
    return this.sessionManager.getOptOut();
  }

  set optOut(optOut) {
    var _this$sessionManager;

    (_this$sessionManager = this.sessionManager) === null || _this$sessionManager === void 0 ? void 0 : _this$sessionManager.setOptOut(Boolean(optOut));
  }

  get lastEventTime() {
    return this.sessionManager.getLastEventTime();
  }

  set lastEventTime(lastEventTime) {
    this.sessionManager.setLastEventTime(lastEventTime);
  }

}
export const useReactNativeConfig = async (apiKey, userId, options) => {
  var _options$domain2, _options$optOut, _await$cookieStorage$, _await$cookieStorage$2, _options$transportPro2;

  const defaultConfig = getDefaultConfig();
  const domain = (_options$domain2 = options === null || options === void 0 ? void 0 : options.domain) !== null && _options$domain2 !== void 0 ? _options$domain2 : await getTopLevelDomain();
  const cookieStorage = await createCookieStorage({ ...options,
    domain
  });
  const cookieName = getCookieName(apiKey);
  const cookies = await cookieStorage.get(cookieName);
  const queryParams = getQueryParams();
  const sessionManager = await new SessionManager(cookieStorage, apiKey).load();
  return new ReactNativeConfig(apiKey, userId !== null && userId !== void 0 ? userId : cookies === null || cookies === void 0 ? void 0 : cookies.userId, { ...options,
    cookieStorage,
    sessionManager,
    deviceId: createDeviceId(cookies === null || cookies === void 0 ? void 0 : cookies.deviceId, options === null || options === void 0 ? void 0 : options.deviceId, queryParams.deviceId),
    domain,
    optOut: (_options$optOut = options === null || options === void 0 ? void 0 : options.optOut) !== null && _options$optOut !== void 0 ? _options$optOut : Boolean(cookies === null || cookies === void 0 ? void 0 : cookies.optOut),
    sessionId: (_await$cookieStorage$ = (_await$cookieStorage$2 = await cookieStorage.get(cookieName)) === null || _await$cookieStorage$2 === void 0 ? void 0 : _await$cookieStorage$2.sessionId) !== null && _await$cookieStorage$ !== void 0 ? _await$cookieStorage$ : options === null || options === void 0 ? void 0 : options.sessionId,
    storageProvider: await createEventsStorage(options),
    trackingOptions: { ...defaultConfig.trackingOptions,
      ...(options === null || options === void 0 ? void 0 : options.trackingOptions)
    },
    transportProvider: (_options$transportPro2 = options === null || options === void 0 ? void 0 : options.transportProvider) !== null && _options$transportPro2 !== void 0 ? _options$transportPro2 : new FetchTransport()
  });
};
export const createCookieStorage = async function (overrides) {
  let baseConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getDefaultConfig();
  const options = { ...baseConfig,
    ...overrides
  };
  const cookieStorage = overrides === null || overrides === void 0 ? void 0 : overrides.cookieStorage;

  if (!cookieStorage || !(await cookieStorage.isEnabled())) {
    return createFlexibleStorage(options);
  }

  return cookieStorage;
};
export const createFlexibleStorage = async options => {
  let storage = new CookieStorage({
    domain: options.domain,
    expirationDays: options.cookieExpiration,
    sameSite: options.cookieSameSite,
    secure: options.cookieSecure
  });

  if (options.disableCookies || !(await storage.isEnabled())) {
    storage = new LocalStorage();

    if (!(await storage.isEnabled())) {
      storage = new MemoryStorage();
    }
  }

  return storage;
};
export const createEventsStorage = async overrides => {
  const hasStorageProviderProperty = overrides && Object.prototype.hasOwnProperty.call(overrides, 'storageProvider'); // If storageProperty is explicitly undefined like `{ storageProperty: undefined }`
  // then storageProvider is undefined
  // If storageProvider is implicitly undefined like `{ }`
  // then storageProvider is LocalStorage
  // Otherwise storageProvider is overriden

  if (!hasStorageProviderProperty || overrides.storageProvider) {
    for (const storage of [overrides === null || overrides === void 0 ? void 0 : overrides.storageProvider, new LocalStorage()]) {
      if (storage && (await storage.isEnabled())) {
        return storage;
      }
    }
  }

  return undefined;
};
export const createDeviceId = (idFromCookies, idFromOptions, idFromQueryParams) => {
  return idFromOptions || idFromQueryParams || idFromCookies || UUID();
};
export const getTopLevelDomain = async url => {
  if (!(await new CookieStorage().isEnabled()) || !url && typeof location === 'undefined') {
    return '';
  }

  const host = url !== null && url !== void 0 ? url : location.hostname;
  const parts = host.split('.');
  const levels = [];
  const storageKey = 'AMP_TLDTEST';

  for (let i = parts.length - 2; i >= 0; --i) {
    levels.push(parts.slice(i).join('.'));
  }

  for (let i = 0; i < levels.length; i++) {
    const domain = levels[i];
    const options = {
      domain: '.' + domain
    };
    const storage = new CookieStorage(options);
    await storage.set(storageKey, 1);
    const value = await storage.get(storageKey);

    if (value) {
      await storage.remove(storageKey);
      return '.' + domain;
    }
  }

  return '';
};
//# sourceMappingURL=config.js.map